/**
 * Mega Menu functionality - Mobile overlay navigation
 * Handles hamburger menu and full-screen overlay navigation
 */
(function (global, $) {
  "use strict";

  // Prevent duplicate initialization
  if (global.megaMenuInitialized) {
    console.log("Mega menu already initialized, skipping...");
    return;
  }

  // Use our utility functions (should be loaded before this file)
  const on =
    global.on ||
    function (element, event, handler, options) {
      const elements = Array.isArray(element) ? element : [element];
      elements.forEach((el) => {
        if (el && el.addEventListener) {
          el.addEventListener(event, handler, options);
        }
      });
      return () => {
        elements.forEach((el) => {
          if (el && el.removeEventListener) {
            el.removeEventListener(event, handler, options);
          }
        });
      };
    };

  const onDocumentReady =
    global.onDocumentReady ||
    function (callback) {
      if (document.readyState !== "loading") {
        setTimeout(callback, 0);
      } else {
        document.addEventListener("DOMContentLoaded", callback, { once: true });
      }
    };

  // Helper functions for DOM manipulation
  const addClass = (element, className) => {
    if (element) element.classList.add(className);
  };

  const removeClass = (element, className) => {
    if (element) element.classList.remove(className);
  };

  const hasClass = (element, className) => {
    return element ? element.classList.contains(className) : false;
  };

  // Main mega menu functionality
  const initMegaMenu = () => {
    // Prevent duplicate initialization
    if (global.megaMenuInitialized) {
      console.log("Mega menu already initialized");
      return;
    }

    console.log("Initializing mega menu...");

    const navbarToggle = document.getElementById("navbar-toggle");
    const megaMenu = document.getElementById("mega-menu");
    const megaMenuClose = document.getElementById("mega-menu-close");

    console.log("Mega menu elements found:", {
      navbarToggle: !!navbarToggle,
      megaMenu: !!megaMenu,
      megaMenuClose: !!megaMenuClose,
    });

    // Check if required elements exist
    if (!navbarToggle || !megaMenu) {
      console.log(
        "Required mega menu elements not found, skipping initialization"
      );
      return;
    }

    // Mark as initialized early to prevent duplicates
    global.megaMenuInitialized = true;

    console.log("Setting up mega menu event listeners...");

    // Track menu state to prevent rapid toggling
    let isToggling = false;

    // Function to open mega menu
    function openMegaMenu() {
      if (isToggling) return;
      isToggling = true;

      // Remove hidden before adding active so CSS transition can run
      megaMenu.removeAttribute("hidden");

      // Double rAF ensures the display change is committed before transitioning
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          addClass(megaMenu, "mega-menu--active");
          addClass(document.body, "mega-menu-open");

          if (navbarToggle) {
            navbarToggle.setAttribute("aria-expanded", "true");
            addClass(navbarToggle, "navbar__toggle--active");
          }

          // Focus management for accessibility
          // Focus immediately — mega-menu--active is set so visibility:visible is in effect
          var firstLink = megaMenu.querySelector(
            ".mega-menu__link, .mega-menu__title a"
          );
          if (firstLink) {
            firstLink.focus();
          }

          // WordPress/jQuery compatibility - trigger custom event
          if ($ && typeof $.fn.trigger === "function") {
            $(megaMenu).trigger("megamenu:opened");
          }

          isToggling = false;
        });
      });
    }

    // Function to close mega menu
    function closeMegaMenu() {
      if (isToggling) return;
      isToggling = true;

      removeClass(megaMenu, "mega-menu--active");
      removeClass(document.body, "mega-menu-open");

      if (navbarToggle) {
        navbarToggle.setAttribute("aria-expanded", "false");
        removeClass(navbarToggle, "navbar__toggle--active");
      }

      // Return focus to toggle button
      if (navbarToggle) {
        setTimeout(function () { navbarToggle.focus(); }, 100);
      }

      // WordPress/jQuery compatibility - trigger custom event
      if ($ && typeof $.fn.trigger === "function") {
        $(megaMenu).trigger("megamenu:closed");
      }

      // Hide from all users after the CSS transition completes
      function onTransitionEnd(e) {
        if (e.propertyName !== "opacity") return;
        megaMenu.removeEventListener("transitionend", onTransitionEnd);
        megaMenu.setAttribute("hidden", "");
        isToggling = false;
      }
      megaMenu.addEventListener("transitionend", onTransitionEnd);

      // Fallback in case transitionend doesn't fire (e.g. reduced-motion)
      setTimeout(function () {
        if (isToggling) {
          megaMenu.setAttribute("hidden", "");
          isToggling = false;
        }
      }, 400);
    }

    // Toggle mega menu (hamburger button)
    const offToggle = on(navbarToggle, "click", (e) => {
      e.preventDefault();
      e.stopPropagation();

      // Prevent rapid clicking
      if (isToggling) {
        console.log("Toggle ignored - animation in progress");
        return;
      }

      console.log(
        "Hamburger toggle clicked - current state:",
        hasClass(megaMenu, "mega-menu--active")
      );

      if (hasClass(megaMenu, "mega-menu--active")) {
        closeMegaMenu();
      } else {
        openMegaMenu();
      }
    });

    // Close mega menu (close button)
    let offClose;
    if (megaMenuClose) {
      offClose = on(megaMenuClose, "click", (e) => {
        e.preventDefault();
        e.stopPropagation();
        console.log("Close button clicked");
        closeMegaMenu();
      });
    }

    // Close on background click (only the overlay itself, not content)
    const offBackground = on(megaMenu, "click", (e) => {
      // Only close if clicking the overlay background, not the content
      if (e.target === megaMenu) {
        console.log("Background clicked, closing mega menu");
        closeMegaMenu();
      }
    });

    // Close on escape key
    const offEscape = on(document, "keydown", (e) => {
      if (e.key === "Escape" && hasClass(megaMenu, "mega-menu--active")) {
        console.log("Escape key pressed, closing mega menu");
        closeMegaMenu();
      }
    });

    // Handle menu link clicks - DO NOT prevent default navigation
    const menuLinks = megaMenu.querySelectorAll(
      ".mega-menu__link, .mega-menu__title a"
    );
    menuLinks.forEach((link) => {
      on(link, "click", (e) => {
        const href = link.getAttribute("href");

        // Only prevent default for placeholder links (#)
        if (href === "#" || href === "") {
          e.preventDefault();
          console.log("Placeholder link clicked, prevented default");
          return;
        }

        // Check if this is an anchor link (contains #)
        const hasAnchor = href && href.includes("#");

        if (hasAnchor) {
          // For anchor links, close menu immediately and handle navigation manually
          // This ensures body overflow:hidden is removed before scroll
          e.preventDefault();
          console.log("Anchor link clicked:", href);

          // Close menu immediately (without focus return to toggle)
          removeClass(megaMenu, "mega-menu--active");
          removeClass(document.body, "mega-menu-open");
          megaMenu.setAttribute("hidden", "");

          if (navbarToggle) {
            navbarToggle.setAttribute("aria-expanded", "false");
            removeClass(navbarToggle, "navbar__toggle--active");
          }

          // Navigate after menu is closed
          setTimeout(() => {
            window.location.href = href;
          }, 50);
        } else {
          // Regular links - allow normal navigation and close menu
          console.log(
            "Menu link clicked, allowing navigation and closing menu"
          );
          setTimeout(() => closeMegaMenu(), 100);
        }
      });
    });

    console.log("Mega menu event listeners setup complete!");

    // Enhanced keyboard navigation for accessibility
    setupKeyboardNavigation(megaMenu);

    // Store cleanup functions for potential later use
    global.megaMenuCleanup = () => {
      if (offToggle) offToggle();
      if (offClose) offClose();
      if (offBackground) offBackground();
      if (offEscape) offEscape();
      global.megaMenuInitialized = false;
    };
  };

  // Enhanced keyboard navigation for the mega menu
  function setupKeyboardNavigation(megaMenu) {
    const menuLinks = megaMenu.querySelectorAll(
      ".mega-menu__link, .mega-menu__title a"
    );
    const menuArray = Array.from(menuLinks);

    menuLinks.forEach((link, index) => {
      on(link, "keydown", (e) => {
        switch (e.key) {
          case "ArrowDown":
            e.preventDefault();
            const nextIndex = (index + 1) % menuArray.length;
            menuArray[nextIndex].focus();
            break;

          case "ArrowUp":
            e.preventDefault();
            const prevIndex = index === 0 ? menuArray.length - 1 : index - 1;
            menuArray[prevIndex].focus();
            break;

          case "Home":
            e.preventDefault();
            menuArray[0].focus();
            break;

          case "End":
            e.preventDefault();
            menuArray[menuArray.length - 1].focus();
            break;
        }
      });
    });

    // Focus trap: keep Tab cycling within the mega menu
    on(megaMenu, "keydown", (e) => {
      if (e.key !== "Tab") return;
      if (!hasClass(megaMenu, "mega-menu--active")) return;

      var focusable = megaMenu.querySelectorAll(
        'a[href], button:not([disabled]), input:not([disabled]), [tabindex]:not([tabindex="-1"])'
      );
      if (!focusable.length) return;

      var first = focusable[0];
      var last = focusable[focusable.length - 1];

      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    });
  }

  // Initialize when DOM is ready - but only once
  onDocumentReady(() => {
    if (!global.megaMenuInitialized) {
      initMegaMenu();
    }
  });

  // Make initialization function available globally
  global.initMegaMenu = initMegaMenu;
})(
  typeof window !== "undefined" ? window : this,
  typeof jQuery !== "undefined" ? jQuery : undefined
);
